<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('table_label_search') ||
                  '样品款号/样品名称(中/英文)/产品线搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="openEditPage({ pageType: 'add', params: {} })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
            <el-badge
              :value="checkedCount"
              class="checked-action-button ml-2"
              :class="{ clearable: !!checkedCount }"
              v-if="allow('E')"
            >
              <b-button
                size="sm"
                class="checked-action-button"
                variant="outline-success"
                @click="exportData"
                :disabled="checkedCount < 1"
              >
                <b-icon-download></b-icon-download>
                {{ $l('INDEX.btn_export') || '导出' }}
                <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
              </b-button>
            </el-badge>
            <el-badge
              :value="checkedCount"
              class="checked-action-button ml-3"
              :class="{ clearable: !!checkedCount }"
              v-if="allow('B')"
            >
              <b-button
                size="sm"
                class="checked-action-button"
                variant="outline-success"
                @click="updateSalePerson()"
                :disabled="checkedCount < 1"
              >
                {{ $l('INDEX.form_label_salesman_adjustment') || '业务人员调整' }}
                <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
              </b-button>
            </el-badge>
            <el-badge
              :value="checkedCount"
              class="checked-action-button ml-3"
              :class="{ clearable: !!checkedCount }"
              v-if="allow('L')"
            >
              <b-button
                size="sm"
                class="checked-action-button"
                variant="outline-success"
                @click="updateDesigner()"
                :disabled="checkedCount < 1"
              >
                {{ $l('INDEX.form_label_designer_adjustment') || '设计师调整' }}
                <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
              </b-button>
            </el-badge>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" size="small" :model="form" label-width="130px">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.Status') || '有效状态'">
              <el-checkbox-group v-model="form.sampleStatusList">
                <el-checkbox label="Y">{{
                  $l('INDEX.form_label_new') || '新增'
                }}</el-checkbox>
                <el-checkbox label="S">{{
                  $l('INDEX.form_label_reviewed') || '已审核'
                }}</el-checkbox>
                <el-checkbox label="N">{{
                  $l('INDEX.form_label_deleted') || '已删除'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('from_label_sample_style_no') || '样品款号'"
            >
              <el-input
                v-model.trim="form.sampleStyleNo"
                :placeholder="
                  $l('table_label_pe_input_sample_style_no') || '请输入样品款号'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-row :gutter="10">
              <el-form-item :label="$l('table_label_productLine') || '产品线'">
                <el-col :span="8">
                  <dict-select
                    :placeholder="
                      $l('table_label_pe_select_productLine') || '请选择产品线'
                    "
                    size="small"
                    clearable
                    filterable
                    v-model="form.productLine"
                    :body="productLineParams"
                    url="/sys/common/dict/system"
                  ></dict-select>
                </el-col>
                <el-col :span="8">
                  <dict-select
                    :placeholder="
                      $l('pe_select_Level_1_sample_classification') ||
                        '请选择1级样品分类'
                    "
                    size="small"
                    clearable
                    filterable
                    v-model="form.masterCategoryCode"
                    :body="queryMasterCategoryParams"
                    url="/master/masterCategory/select"
                  ></dict-select>
                </el-col>
                <el-col :span="8">
                  <dict-select
                    :placeholder="
                      $l('pe_select_Level_2_sample_classification') ||
                        '请选择2级样品分类'
                    "
                    size="small"
                    clearable
                    filterable
                    v-model="form.categoryCode"
                    :body="queryCategoryParams"
                    url="/master/masterCategory/select"
                  ></dict-select>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_sampleSource') || '样品来源'">
              <dict-select
                :placeholder="$l('pe_select_sampleSource') || '请选择样品来源'"
                size="small"
                clearable
                filterable
                v-model="form.sampleSource"
                :body="{ dictType: 'sampleSource' }"
                url="/master/common/dict/biz"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_business_name') || '业务人员'"
            >
              <dict-select
                clearable
                v-model="form.salesPersonCode"
                filterable
                size="small"
                url="/master/common/dict/userSelect/all"
                :placeholder="
                  $l('INDEX.form_label_please_select_a_business_person') ||
                    '请选择业务人员'
                "
                :selectedLabel.sync="form.salesPersonName"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.form_label_designer') || '设计师'">
              <dict-select
                clearable
                v-model="form.designerCode"
                filterable
                size="small"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_designer') ||
                    '请选择设计师'
                "
                :selectedLabel.sync="form.designerName"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('from_label_sample_name_cn') || '样品中文名称'"
            >
              <el-input
                v-model.trim="form.sampleName"
                :placeholder="
                  $l('table_label_pe_input_sampleNamecn') ||
                    '请输入样品中文名称'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_factory') || '成品工厂'">
              <dict-select
                :placeholder="$l('pe_select_factory') || '请选择成品工厂'"
                size="small"
                clearable
                multiple
                filterable
                v-model="form.scmCodeList"
                :body="scmParams"
                url="/master/common/dict/scm"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('table_label_factory_product_number') || '工厂产品编号'
              "
            >
              <el-input
                v-model.trim="form.scmProductNo"
                :placeholder="
                  $l('pe_select_factory_product_number') || '请输入工厂产品编号'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              size="small"
              :label="$l('INDEX.label_customer') || '客户'"
            >
              <dict-select
                clearable
                v-model="form.custCodeList"
                multiple
                filterable
                url="/master/common/dict/customerSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_a_customer') ||
                    '请选择客户'
                "
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              size="small"
              :label="$l('INDEX.form_label_brand') || '品牌'"
            >
              <dict-select
                clearable
                v-model="form.brandCode"
                filterable
                url="/master/common/dict/brandSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_brand') || '请选择品牌'
                "
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_quotation_method') || '报价方式'"
              prop="quotedMethod"
            >
              <dict-select
                size="small"
                clearable
                filterable
                v-model="form.quotedMethod"
                :body="{ dictType: 'quotedMethod' }"
                :placeholder="
                  $l('pe_select_quotation_method') || '请选择报价方式'
                "
                url="/sys/common/dict/system"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('table_label_moq') || '起订量'">
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0"
                    :step="1"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.moqStart"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    size="small"
                    style="width: 100%"
                    :min="0"
                    :step="1"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.moqEnd"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <el-form-item>
                    <dict-select
                      :placeholder="
                        $l('table_label_moqUnit') || '请选择起订量单位'
                      "
                      size="small"
                      clearable
                      filterable
                      v-model="form.moqUnit"
                      :body="moqUnitParams"
                      url="/master/common/dict/biz"
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('table_label_costPrice') || '单价'">
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0"
                    :step="1"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.costPriceStart"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    size="small"
                    style="width: 100%"
                    :min="0"
                    :step="1"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.costPriceEnd"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <el-form-item>
                    <dict-select
                      :placeholder="
                        $l('table_label_costCurrency') || '请选择货币单位'
                      "
                      size="small"
                      clearable
                      filterable
                      v-model="form.currencyUnit"
                      :body="currencyUnitParams"
                      url="/master/common/dict/biz"
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('table_label_quotedPrice') || '建议报价'"
              >
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0"
                    :step="1"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.quotedPriceStart"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    size="small"
                    style="width: 100%"
                    :min="0"
                    :step="1"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.quotedPriceEnd"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <dict-select
                    size="small"
                    clearable
                    filterable
                    v-model="form.quotedCurrency"
                    :body="{ dictType: 'quotedCurrency' }"
                    :placeholder="
                      $l('pe_select_quotedCurrency') || '请选择建议报价币种'
                    "
                    url="/sys/common/dict/system"
                  ></dict-select>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_customerProductNo') || '客人产品编号'"
            >
              <el-input
                v-model="form.customerProductNo"
                :placeholder="
                  $l('pe_select_customerProductNo') || '请输入客人产品编号'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_ftyPersonCode') || '工厂业务人员'">
              <dict-select
                clearable
                v-model="form.ftyPersonCode"
                filterable
                size="small"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('pe_choose_customerProductNo') || '请选择工厂业务人员'"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_poNo') || 'PO单号'">
              <el-input v-model="form.poNo" clearable size="small"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_custSampleName') || '客户样品名称'"
            >
              <el-input v-model="form.custSampleName" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_sampleSetNo') || '套件编号'">
              <el-input v-model="form.sampleSetNo" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_listIsSingle') || '是否单品'">
              <el-checkbox-group v-model="form.listIsSingle">
                <el-checkbox label="Y">{{ $l('INDEX.YES') || "是" }}</el-checkbox>
                <el-checkbox label="N">{{ $l('INDEX.否') || "否" }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.table_label_modification_date') || '修改时间'"
              >
                <el-col :span="24">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyTimeStart"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyTimeEnd"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('form_label_dateOfSignatureBegin') || '签样日期'"
              >
                <el-col :span="24">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.dateOfSignatureBegin"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.dateOfSignatureEnd"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_inputSource') || '样品输入来源'"
            >
              <dict-select
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                clearable
                filterable
                v-model="form.inputSource"
                :body="{ dictType: 'sampleInputSource' }"
                url="/master/common/dict/biz"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  sampleStatusList: ['Y', 'S'],
  listIsSingle: ['Y', 'N'],
  productLineList: [],
  scmCodeList: [],
  custCodeList: [],
}
export default {
  props: {
    checkedCount: { type: Number, default: 0 },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      productLineParams: { dictType: 'productLine' },
      scmParams: {},
      moqUnitParams: { dictType: 'moqUnit' },
      currencyUnitParams: { dictType: 'currencyUnit' },
      masterCategoryParams: { parentCode: '', isEcom: 'N' },

      queryMasterCategoryParams: { parentCode: 'x', isEcom: 'N' },
      queryCategoryParams: { parentCode: 'x', isEcom: 'N' },
    }
  },
  watch: {
    // 查询条件下拉
    'form.productLine'() {
      this.form.masterCategoryCode = ''
      this.form.categoryCode = ''
      this.queryCategoryParams = { parentCode: '', isEcom: 'N' }
      this.queryMasterCategoryParams = {
        parentCode: this.form.productLine,
        isEcom: 'N',
      }
    },
    'form.masterCategoryCode'() {
      this.form.categoryCode = ''
      this.queryCategoryParams = {
        parentCode: this.form.masterCategoryCode,
        isEcom: 'N',
      }
    },
  },
  methods: {
    clearCheckboxRow() {
      this.$emit('clearCheckboxRow')
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = {
        keyword: '',
        sampleStatusList: ['Y', 'S'],
        productLineList: [],
        scmCodeList: [],
        custCodeList: [],
      }
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    async openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'sample-sampleInformation-detail',
        params: { ...params, pageType },
      })
    },
    exportData() {
      this.$emit('exportData')
    },
    updateSalePerson() {
      this.$emit('updateSalePerson')
    },
    updateDesigner() {
      this.$emit('updateDesigner')
    },
  },
}
</script>
<style lang="scss" scoped>
.checked-action-button {
  .el-icon-circle-close {
    display: none;
  }
}

.checked-action-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }

  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
